export const MISSING_SEARCH_BY_ERROR = {
    title: 'Client Error',
    description: 'Select a value to search by (title, uuid, etc.).',
    id: 'missing-search-by-error',
    status: 'error' as const,
    duration: 8000,
    isClosable: true
};
